<script setup lang="ts">
import { isVotingPeriod } from '~/lib/vote';
import { getVotedStall } from '~/lib/vote';

definePageMeta({
  title: "模擬店大賞 - 投票確認",
})
</script>

<template>
  <article class="flex flex-col items-center max-w-[900px] mx-auto px-[8px]">
    <Ribbon class="mt-6 mb-8 text-md md:text-2xl">
      模擬店大賞 - 投票確認
    </Ribbon>

    <ClientOnly>
      <template v-if="getVotedStall()">
        <div class="mb-8 text-md md:text-xl text-center">
          投票はすでに完了しています！ <br/>
          投票先：{{ getVotedStall() }}
        </div>
      </template>
      <template v-else>
        <div class="mb-8 text-md md:text-xl text-center">
          投票はまだされていないようです・・・
        </div>
        <div class="mb-6 w-full max-w-[350px]">
          <NuxtLink
            v-if="isVotingPeriod()"
            class="btn text-xl h-16 btn-outline text-gray-700 hover:text-gray-700 hover:bg-stone-200 border-2 flex flex-col border-primary"
            to="/best-booth-award/form"
          >
            投票はこちらから！
          </NuxtLink>
        </div>
      </template>
    </ClientOnly>

    <div class="mb-4">
      <NuxtLink class="btn btn-primary" to="/">
        トップに戻る
      </NuxtLink>
    </div>
  </article>
</template>